"use client";

import { Icons } from "@/components/icons";
import { motion } from "src/lib/motion";
import { useTranslations } from "@/lib/hooks/use-translations";

export default function AboutHero() {
  const { t } = useTranslations();

  return (
    <div className="bg-background">
      <div className="mx-auto w-full max-w-screen-xl px-6 mt-16 md:mt-24">
        <div className="text-center py-8 md:py-16">
          <motion.div
            className="flex justify-center mb-8"
            initial={{ opacity: 0, scale: 0.5 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
          >
            <Icons.logo className="w-auto h-[60px] md:h-[80px]" />
          </motion.div>
          <motion.h1
            className="text-3xl font-bold text-foreground sm:text-4xl"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.3 }}
          >
            {t('pages.about.hero.title')}
          </motion.h1>
          <motion.p
            className="mt-4 text-xl text-muted-foreground"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.5 }}
          >
            {t('pages.about.hero.description')}
          </motion.p>
        </div>
      </div>
    </div>
  );
}
